var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSponsors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C12.48 8 8 12.48 8 18C8 23.52 12.48 28 18 28C23.52 28 28 23.52 28 18C28 12.48 23.52 8 18 8ZM19.41 24.09V26H16.74V24.07C15.03 23.71 13.58 22.61 13.47 20.67H15.43C15.53 21.72 16.25 22.54 18.08 22.54C20.04 22.54 20.48 21.56 20.48 20.95C20.48 20.12 20.04 19.34 17.81 18.81C15.33 18.21 13.63 17.19 13.63 15.14C13.63 13.42 15.02 12.3 16.74 11.93V10H19.41V11.95C21.27 12.4 22.2 13.81 22.26 15.34H20.3C20.25 14.23 19.66 13.47 18.08 13.47C16.58 13.47 15.68 14.15 15.68 15.11C15.68 15.95 16.33 16.5 18.35 17.02C20.37 17.54 22.53 18.41 22.53 20.93C22.52 22.76 21.15 23.76 19.41 24.09Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsors);
export default __webpack_public_path__ + "static/media/sponsors.19bd17bc8b79e3c1a570ac9d00c52d4b.svg";
export { ForwardRef as ReactComponent };